// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"291341a7","330":"3ded6d5c","425":"334b7f60","514":"27c539f2","572":"07ea2152","637":"57f7ff83","736":"d3382ab5","764":"8235b7ac","853":"0933743f"}[chunkId] + ".chunk.js";
};